import React, { useState } from 'react'
import login1 from '../Assets/login1.png'
import login2 from '../Assets/login2.png'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { Create_Api } from '../ApiUrls'

function Login() {
    const navigate = useNavigate();
    const [IsUploading, setIsUploading] = useState(false);
    const [Email, setEmail] = useState('');
    const [Password, setPassword] = useState('');


    const UserLogin = async () => {
        if (!Email || !Password) {
            toast.error('Email and Password are required!');
            return;
        }
        try {
            let data = {
                Email,
                Password
            }
            setIsUploading(true)
            const response = await Create_Api(`api/user/Login`, data)
            console.log('User Login Successfull:', response);
            localStorage.setItem('user', JSON.stringify(response?.data));
            localStorage.setItem('userid', response?.data?.User?._id);
            localStorage.setItem('userToken', response?.data?.token);
            toast.success(response?.message);
            setEmail('')
            setPassword('')
            navigate('/')
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error)
        }
    }


    return (
        <>
            <Navbar />
            <div className="login-page">
                <div className="login-header">
                    <h1>Log In</h1>
                    <p>
                        Home / <span className="active">Log In</span>
                    </p>
                </div>

                <div className="login-container">
                    <div className="login-image">
                        <img src={login2} alt="Login Illustration" />
                    </div>
                    <div className="login-form">
                        <h2>Login</h2>
                        <p>Login to access your ADL Account</p>
                        <label>Email</label>
                        <input
                            type="email"
                            placeholder="john.doe@gmail.com"
                            value={Email}
                            onChange={(e) => { setEmail(e.target.value) }}
                            required
                        />
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="*********"
                            value={Password}
                            onChange={(e) => { setPassword(e.target.value) }}
                            required
                        />
                        <div className="form-options">
                            <label>
                                <input type="checkbox" />
                                Remember me
                            </label>
                            <a href="/forgot-password" className="forgot-password">
                                Forgot Password?
                            </a>
                        </div>
                        <button onClick={UserLogin} className="login-btn">
                            {IsUploading ? "Please Wait" : "Login"}
                        </button>

                        <p>
                            Don’t have an account? <a href="/signup">Sign up</a>
                        </p>

                    </div>
                </div>
            </div>
            <br />
            <Footer />
        </>
    )
}

export default Login